// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"2371":"verify-page","4695":"better-scroll"}[chunkId] || chunkId) + ".js";
};